import styled from 'styled-components'

function SvgAddressIcon(props) {
  return (
    <svg
      width={12}
      height={16}
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.78242 2.547C2.90101 1.42841 4.41815 0.799988 6.00008 0.799988C7.58201 0.799988 9.09915 1.42841 10.2177 2.547C11.3363 3.66559 11.9648 5.18273 11.9648 6.76466C11.9648 8.34659 11.3363 9.86373 10.2177 10.9823L6.00008 15.2L1.78242 10.9823C1.22851 10.4285 0.789123 9.77094 0.489347 9.04727C0.189571 8.3236 0.0352783 7.54797 0.0352783 6.76466C0.0352783 5.98136 0.189571 5.20573 0.489347 4.48206C0.789123 3.75839 1.22851 3.10085 1.78242 2.547ZM6.00008 8.46877C6.45204 8.46877 6.88548 8.28923 7.20507 7.96965C7.52465 7.65007 7.70419 7.21662 7.70419 6.76466C7.70419 6.31271 7.52465 5.87926 7.20507 5.55968C6.88548 5.2401 6.45204 5.06056 6.00008 5.06056C5.54812 5.06056 5.11468 5.2401 4.7951 5.55968C4.47551 5.87926 4.29597 6.31271 4.29597 6.76466C4.29597 7.21662 4.47551 7.65007 4.7951 7.96965C5.11468 8.28923 5.54812 8.46877 6.00008 8.46877Z"
        fill="#03A0CE"
      />
    </svg>
  )
}

export default styled(SvgAddressIcon)``
